import { palette } from "@layout";

/**
 * Design tokens for the redesigned entry experience, ported from the
 * mobile app (future-money-mobile: src/layout + src/gradients/colors.ts)
 * and the "FutureMoney UI — Mobile (Updates)" desktop mockups.
 */

export const entryFont = {
  title: `"Playfair Display", Georgia, "Times New Roman", serif`,
  body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
} as const;

export const entryColors = {
  // Base scrim + glow, identical to mobile DarkOverlay
  navy: palette.black[100], // #090B1F
  scrim: "rgba(9, 11, 31, 0.75)",
  warmBrownDark: "rgb(34, 21, 5)",
  warmBrownMid: "rgb(143, 82, 53)",
  warmCopper: "rgb(205, 128, 84)",

  // CTAs (sampled from mockups; copper == palette.lightbrown[100])
  terracotta: "#CD8054",
  terracottaDeep: "#BB6852",
  green: "#3D6A52",
  greenDeep: "#2E5240",

  // Text
  textPrimary: palette.white[100],
  textSecondary: "rgba(255, 255, 255, 0.75)",
  textTertiary: palette.white[40],
  highlight: palette.manhattan[100], // #F7B696 – "Amber."
  error: "#ECAEB0", // palette.pink – readable error tone on dark

  // Glass surfaces
  glassFill: "rgba(244, 241, 242, 0.10)",
  glassFillStrong: "rgba(244, 241, 242, 0.16)",
  glassBorder: "rgba(255, 255, 255, 0.22)",
  glassBorderFocus: "rgba(255, 255, 255, 0.55)",
  chipWarmFill: "rgba(205, 128, 84, 0.22)",
  chipWarmBorder: "rgba(205, 128, 84, 0.38)",
} as const;

/** Animation grammar, 1:1 with mobile useOnboardingAnimation. */
export const entryMotion = {
  slideDistance: 40,
  ctaHeight: 50,
  easing: "cubic-bezier(0.42, 0, 0.58, 1)",
  content: { transform: 600, opacity: 800 },
  contentUnified: { transform: 600, opacity: 700 },
  form: { transform: 500, opacity: 600 },
  button: { transform: 500, opacity: 600 },
  out: 400,
  dimmedContentOpacity: 0.5,
  greetingHold: 1000,
} as const;

export const entryLayout = {
  formWidth: 460,
  ctaWidth: 420,
  radiusInput: 16,
  radiusPill: 50,
  ctaHeightPx: 56,
} as const;

export const ENTRY_VIDEO_BACKGROUND = "/videos/onboarding-background.mp4";
export const ENTRY_VIDEO_FAMILY = "/videos/lifting-laughing-baby.mp4";

export const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
